/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Context } from 'context/AuthContext';
import { GET_LIST_SOLICITACAO_USUARIO } from 'services/Consulta';
import { CREATE_RASCUNHO_COPIA_SOLICITACAO } from 'services/Solicitacao';
import { Button, Modal } from 'react-bootstrap';

import './styles.scss';

const ContentHistoricoSolicitacoes = () => {
  const { showLoader } = useContext(Context);
  const [model, setModel] = useState([]);
  const history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    (async () => {
      showLoader(true);
      try {
        const data = await GET_LIST_SOLICITACAO_USUARIO();
        if (data?.value) {
          setModel(data.value);
        }
      } catch (error) {
        console.error('Erro ao buscar solicitações:', error);
      } finally {
        showLoader(false);
      }
    })();
  }, []);

  const solicitar = (solicitacaoId) => {
    (async () => {
      showLoader(true);
      try {
        const response = await CREATE_RASCUNHO_COPIA_SOLICITACAO(solicitacaoId);

        if (response?.value?.rascunhoId) {
          history.push(`/pedido-materiais/${response.value.rascunhoId}`);
        } else {
          setModalMessage(
            response?.message ||
              'Este material não está mais disponível, por favor escolha outra solicitação.'
          );
          setShowModal(true);
        }
      } catch (error) {
        const mensagemErro =
          error.response?.data?.message ||
          'Este material não está mais disponível, por favor escolha outra solicitação.';

        setModalMessage(mensagemErro);
        setShowModal(true);
      } finally {
        showLoader(false);
      }
    })();
  };

  return (
    <>
      <div className="table-historico-solicitacoes">
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Nº</th>
                <th>Cliente</th>
                <th style={{ width: '20%' }}>Tipo de Material</th>
                <th>Etapa Atual</th>
                <th>Pendente Para</th>
                <th style={{ width: '210px' }} />
              </tr>
            </thead>
            <tbody>
              {(model || []).map((item, idx) => {
                return (
                  <tr
                    key={idx}
                    className={
                      item.solicitacaoFinalizada ? 'finalizado' : 'andamento'
                    }
                  >
                    <td>{item.solicitacaoId}</td>
                    <td>{item.razaoSocial}</td>
                    <td>{item.materialComunicacao}</td>
                    <td>{item.etapa}</td>
                    <td>{item.usuarioPendencia ?? '-'}</td>
                    <td>
                      <Button
                        variant="primary"
                        className="mb-3"
                        onClick={() => solicitar(item.solicitacaoId)}
                      >
                        SOLICITAR NOVAMENTE
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Aviso</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContentHistoricoSolicitacoes;
